import React from 'react'

let rolesAndPermissions=()=> {
  return (
    <div>rolesAndPermissions</div>
  )
}

export default rolesAndPermissions